import React from 'react';
import HeaderAccessibility from './HeaderAccessibility';

export default function HeaderActions() {
	return (
		<div className="header__actions df-ac">
			<HeaderAccessibility/>
		</div>
	)
}
